import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

/**
 * Loader factory for TranslateModule.
 *
 * Lives in its own file on purpose: it is used by both AppModule and SharedModule,
 * and importing it from AppModule would make those two modules import each other.
 */
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
